function mjsProductFormPublishCommerceEvent(eventName, eventPayload, standardEventName) {
  const ecommerce = {
    currency: eventPayload.currency || 'AUD',
    value: eventPayload.value || 0,
    items: eventPayload.items || [],
  };

  if (window.Shopify?.analytics && typeof window.Shopify.analytics.publish === 'function') {
    try {
      window.Shopify.analytics.publish(eventName, eventPayload);
    } catch (error) {
      // Tracking should never block cart behaviour.
    }
  }

  window.dataLayer = window.dataLayer || [];
  if (typeof window.dataLayer.push === 'function') {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName.replace(/[:]/g, '_'),
      ecommerce,
      mjs_event_id: eventPayload.event_id || '',
      mjs_event_source: eventPayload.event_source || '',
    });

    if (standardEventName) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: standardEventName,
        ecommerce,
        mjs_event_id: eventPayload.event_id || '',
        mjs_event_source: eventPayload.event_source || '',
      });
    }
  }

  try {
    document.dispatchEvent(new CustomEvent(eventName, { detail: eventPayload }));
  } catch (error) {
    // CustomEvent support is best-effort.
  }

  try {
    const commerceEventRecord = {
      event: eventName,
      standard_event: standardEventName || '',
      timestamp: new Date().toISOString(),
      payload: eventPayload,
    };
    const commerceHistory = JSON.parse(sessionStorage.getItem('mjs_commerce_event_history') || '[]');
    commerceHistory.push(commerceEventRecord);
    sessionStorage.setItem('mjs_last_commerce_event', JSON.stringify(commerceEventRecord));
    sessionStorage.setItem('mjs_commerce_event_history', JSON.stringify(commerceHistory.slice(-12)));
  } catch (error) {
    // Storage is diagnostic only.
  }

  try {
    if (new URLSearchParams(window.location.search).get('mjs_debug_tracking') === '1') {
      console.log('[MJS commerce tracking] ' + eventName + ' ' + JSON.stringify(eventPayload));
    }
  } catch (error) {
    // Debug logging is diagnostic only.
  }
}

function mjsProductFormTrackAddToCart(detail = {}) {
  const response = detail.cartAddResponse;
  let addedItems = [];

  if (response && Array.isArray(response.items)) {
    addedItems = response.items;
  } else if (response) {
    addedItems = [response];
  } else if (detail.variantId) {
    addedItems = [{ id: detail.variantId, quantity: detail.quantity || 1 }];
  }

  const items = addedItems.map((item) => {
    const variantId = item.variant_id || item.id || detail.variantId || '';
    const priceCents = typeof item.final_price === 'number' ? item.final_price : item.price;
    const quantity = item.quantity || detail.quantity || 1;
    return {
      item_id: String(variantId),
      item_name: item.product_title || item.title || detail.productTitle || '',
      item_variant: item.variant_title || '',
      price: typeof priceCents === 'number' ? priceCents / 100 : undefined,
      quantity,
    };
  });

  const value = items.reduce((total, item) => total + (Number(item.price) || 0) * (Number(item.quantity) || 1), 0);
  const eventPayload = {
    event_id: 'mjs_atc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10),
    event_source: detail.source || 'product-form',
    currency: 'AUD',
    value: Math.round(value * 100) / 100,
    items,
    variant_id: detail.variantId ? String(detail.variantId) : undefined,
    quantity: detail.quantity || 1,
    page_url: window.location.href,
  };

  mjsProductFormPublishCommerceEvent('mjs:add_to_cart_ajax', eventPayload, 'add_to_cart');
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const mjsAddToCartPayload = {
              source: 'product-form',
              variantId: formData.get('id'),
              quantity: Number(formData.get('quantity') || 1),
              cartAddResponse: response,
            };
            if (typeof window.mjsTrackAjaxAddToCart === 'function') {
              window.mjsTrackAjaxAddToCart(mjsAddToCartPayload);
            } else {
              mjsProductFormTrackAddToCart(mjsAddToCartPayload);
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
